module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents/hero-mobile.07bffa0e520dffa7799a35f746eb8f99.jpg";